import axios from "axios";
import { getHeaders, refreshToken } from "../utils/helper";

import endpoints from "./endpoints";

export const createCases = async data => {
    const callResponse = await axios({
        url: endpoints.cases,
        method: "post",
        headers:{...getHeaders(),"Content-Type":"multipart/form-data"},
        data,
    })
        .then(response => response.data)
        .catch(err => (err.response ? err.response.data : {}));
    return callResponse;
};
export const updateCases = async data => {
    const callResponse = await axios({
        url: endpoints.cases,
        method: "put",        
        headers:{...getHeaders()},
        data,
    })
        .then(response => response.data)
        .catch(err => (err.response ? err.response.data : {}));
    return callResponse;
};
export const fetchCases = async params => {
    const callResponse = await axios({
        url: endpoints.cases,
        method: "get",  
        headers:{...getHeaders()},      
        params,
    })
        .then(response => response.data)
        .catch(err => (err.response ? err.response.data : {}));
    return callResponse;
};